'use strict';

var React = require('react');

var SvgMicrophoneMajor = function SvgMicrophoneMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6 4a4 4 0 1 1 8 0v4a4 4 0 0 1-8 0v-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 15v4h-2v-4h2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8a6 6 0 0 0 12 0h2a8 8 0 1 1-16 0h2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 6h.5a1.5 1.5 0 0 1 1.5 1.5v.5h-2v-2zm-14 1.5a1.5 1.5 0 0 1 1.5-1.5h.5v2h-2v-.5zm5 12a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5v.5h-6v-.5z"
  }));
};

exports.SvgMicrophoneMajor = SvgMicrophoneMajor;
